/*
  FormattedMessages.js - FormattedMessages for the top-level System Monitor Component

  Author: Adarsh Anup (2022)
  Company: Red Oxygen

*/

// NPM MODULES
import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  systemMonitorTitle: (
    <FormattedMessage
      id="Global.systemMonitorTitle"
      defaultMessage="System Monitor"
    />
  ),
  restartButtonTitle: (
    <FormattedMessage
      id="Global.restartButtonTitle"
      defaultMessage="In Case of Emergency, Break Glass:"
    />
  ),
  restartMuxButton: (
    <FormattedMessage
      id="Global.restartMuxButton"
      defaultMessage="Restart Mux (Outbound)"
    />
  ),
  restartMuxModalTitle: (
    <FormattedMessage
      id="Global.restartMuxModalTitle"
      defaultMessage="Mux Restart Confirmation"
    />
  ),
  restartMuxModalBody: (
    <FormattedMessage
      id="Global.restartMuxModalBody"
      defaultMessage="Are you sure you would like to restart the MUX?"
    />
  ),
  restartApiButton: (
    <FormattedMessage
      id="Global.restartApiButton"
      defaultMessage="Restart Api (Inbound)"
    />
  ),
  restartApiModalTitle: (
    <FormattedMessage
      id="Global.restartApiModalTitle"
      defaultMessage="Api Restart Confirmation"
    />
  ),
  restartApiModalBody: (
    <FormattedMessage
      id="Global.restartApiModalBody"
      defaultMessage="Are you sure you would like to restart the API? NOTE: You may see errors while the API is reconnecting to the database"
    />
  ),
  statsTitle: (
    <FormattedMessage
      id="AdminSystemMonitor.statsTitle"
      defaultMessage="SMSC Service"
    />
  ),
  dateText: <FormattedMessage id="Global.dateText" defaultMessage="Date" />,
  typeText: <FormattedMessage id="Global.typeText" defaultMessage="Type" />,
  functionText: (
    <FormattedMessage id="Global.functionText" defaultMessage="Function" />
  ),
  resultText: (
    <FormattedMessage id="Global.resultText" defaultMessage="Result" />
  ),
  totalStatsTitle: (
    <FormattedMessage
      id="AdminSystemMonitor.totalStatsTitle"
      defaultMessage="Total Stats"
    />
  ),
  totalTwilioStatsTitle: (
    <FormattedMessage
      id="AdminSystemMonitor.totalTwilioStatsTitle"
      defaultMessage="Total Twilio Stats"
    />
  ),
  dateUTCText: (
    <FormattedMessage id="Global.dateText" defaultMessage="Date (UTC)" />
  ),
  logLevelText: (
    <FormattedMessage id="Global.logLevelText" defaultMessage="Level" />
  ),
  countText: <FormattedMessage id="Global.countText" defaultMessage="Count" />,
  emailIDText: (
    <FormattedMessage id="Global.emailIDText" defaultMessage="EmailID" />
  ),
  emailText: (
    <FormattedMessage id="Global.emailText" defaultMessage="User Email" />
  ),
};

export default FormattedMessages;
